/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3NodesNodeIdRequest = {
  /**
   * Node ID
   */
  nodeId: string;
};

/** @internal */
export const GetApiV3NodesNodeIdRequest$inboundSchema: z.ZodType<
  GetApiV3NodesNodeIdRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  node_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "node_id": "nodeId",
  });
});

/** @internal */
export type GetApiV3NodesNodeIdRequest$Outbound = {
  node_id: string;
};

/** @internal */
export const GetApiV3NodesNodeIdRequest$outboundSchema: z.ZodType<
  GetApiV3NodesNodeIdRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3NodesNodeIdRequest
> = z.object({
  nodeId: z.string(),
}).transform((v) => {
  return remap$(v, {
    nodeId: "node_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3NodesNodeIdRequest$ {
  /** @deprecated use `GetApiV3NodesNodeIdRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3NodesNodeIdRequest$inboundSchema;
  /** @deprecated use `GetApiV3NodesNodeIdRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3NodesNodeIdRequest$outboundSchema;
  /** @deprecated use `GetApiV3NodesNodeIdRequest$Outbound` instead. */
  export type Outbound = GetApiV3NodesNodeIdRequest$Outbound;
}

export function getApiV3NodesNodeIdRequestToJSON(
  getApiV3NodesNodeIdRequest: GetApiV3NodesNodeIdRequest,
): string {
  return JSON.stringify(
    GetApiV3NodesNodeIdRequest$outboundSchema.parse(getApiV3NodesNodeIdRequest),
  );
}

export function getApiV3NodesNodeIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3NodesNodeIdRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3NodesNodeIdRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3NodesNodeIdRequest' from JSON`,
  );
}
